import { SearchResultsTable } from '../SearchResultsTable';

export const SearchResultsTableLoader = () => {
  return <SearchResultsTable loading rows={[]} />;
};
